import { Link } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";

export default function PolicyLayout({ title, updated, children, testId }) {
  return (
    <div data-testid={testId}>
      <Navbar />
      <section className="bg-[#FFFDF9] py-20 sm:py-28">
        <div className="max-w-3xl mx-auto px-6 sm:px-10">
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#C48B9F]">
            Me Amor · Legal
          </div>
          <h1 className="mt-3 font-serif-me text-4xl sm:text-5xl leading-[1.05] text-[#36292A]">
            {title}
          </h1>
          {updated && (
            <p className="mt-3 text-[11px] tracking-[0.24em] uppercase text-[#7D6B6D]">
              Last updated · {updated}
            </p>
          )}

          <div className="prose prose-neutral mt-10 text-[#36292A] leading-relaxed [&_h2]:font-serif-me [&_h2]:text-2xl [&_h2]:mt-10 [&_h2]:mb-3 [&_h2]:text-[#36292A] [&_h3]:font-serif-me [&_h3]:text-lg [&_h3]:mt-6 [&_h3]:mb-2 [&_p]:my-4 [&_p]:text-[15px] [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:my-4 [&_li]:my-1 [&_li]:text-[15px] [&_a]:text-[#C48B9F] [&_a]:underline [&_a]:underline-offset-4">
            {children}
          </div>

          <div className="mt-16 pt-8 border-t border-[#E8D7D0] text-sm text-[#7D6B6D]">
            Questions?{" "}
            <a
              href="mailto:empower.meamor@gmail.com"
              className="text-[#C48B9F] underline decoration-[#C48B9F] underline-offset-4"
            >
              empower.meamor@gmail.com
            </a>{" "}
            · Or head{" "}
            <Link
              to="/"
              className="text-[#C48B9F] underline decoration-[#C48B9F] underline-offset-4"
            >
              back home
            </Link>
            .
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
